import { StaticPage } from '@dreamstack/accentro-contentful/src/components/StaticPage'
import { PropertyContact } from '@dreamstack/feature-components/src/property/PropertyContact'
import { fetchStaticPageData } from '@dreamstack/payload/src/lib/fetchStaticPageData'
import { cn } from '@dreamstack/util/src/cn'
import { getStaticPropsPlus } from '../lib/getStaticPropsPlus'

// Replacement for StyledPage using a lightweight wrapper + styled-jsx
const StyledPage: React.FC<React.ComponentProps<typeof StaticPage>> = ({
  className,
  ...rest
}) => (
  <div className={cn('StyledPage-root', className)}>
    <StaticPage {...rest} />
    <style jsx>{`
      .StyledPage-root :global(h2) {
        color: #2b2d36;
        display: block;
        --padding-x: 8px;
        --padding-y: 4px;
        --padding-color: #00ffd0;
        padding: 0 var(--padding-x);
      }
      .StyledPage-root :global(h2 span) {
        box-shadow:
          calc(1 * var(--padding-x)) calc(1 * var(--padding-y)) 0
            var(--padding-color),
          calc(-1 * var(--padding-x)) calc(-1 * var(--padding-y)) 0
            var(--padding-color),
          calc(-1 * var(--padding-x)) calc(1 * var(--padding-y)) 0
            var(--padding-color),
          calc(1 * var(--padding-x)) calc(-1 * var(--padding-y)) 0
            var(--padding-color);
        background-color: var(--padding-color);
        box-decoration-break: clone;
      }
      .StyledPage-root :global(p:first-child + h2) {
        margin-top: 0;
      }
    `}</style>
  </div>
)

export default function Home() {
  return (
    <>
      <StyledPage slug={'immoscout24'}>
        <PropertyContact
          broker_email="partner@accentro.de"
          broker_first_name=""
          broker_last_name="ACCENTRO Real Estate AG"
          broker_phone="+49(30) 887 181 7628"
        />
      </StyledPage>
    </>
  )
}

export const getStaticProps = getStaticPropsPlus({
  getProps: async () => {
    const staticPageData = await fetchStaticPageData({
      slug: 'immoscout24',
    })

    // Show 404 when page not published
    if (!staticPageData) {
      return {
        props: {},
        notFound: true,
      }
    }
  },
})
